<template>
    <b-modal id="auth-modal" v-model="codigoModal" title="Autenticação" size="sm" :hide-footer="true">
        <b-form @submit.prevent="salvarDados">
            <div class="body">
                <div class="p-1 text-center c-text-secondary-agenda-pro">
                    <div>
                        <p style="font-size: 14px;" class="text-secondary mb-3">Insira o código de segurança para acessar sua conta:</p>
                        <TokenInput
                            :mostraTempo="!reenviar"
                            :tempo="data.timer"
                            :tamanho="6"
                            @completo="token => this.token = token"
                            tipo="number"
                            @fimTempo="() => this.reenviar = true"
                        />
                    </div>
                    <div v-if="reenviar" class="mt-4 d-flex flex-column align-items-center justify-content-center">
                        <a class="cursor-pointer" @click="$emit('solicitaCodigo')">Código expirado, clique aqui para reenviar</a>
                    </div>
                    <div class="mt-4 d-flex flex-row justify-content-between">
                        <a @click="$emit('voltarCodigo')" class="btn btn-default btn-flat"> Voltar </a>
                        <b-button :disabled="this.token.length < 6" ref="finalizar" @click="$emit('tokenInserido', token)" variant="success"> Entrar </b-button>
                    </div>
                </div>
            </div>
        </b-form>
    </b-modal>
</template>
<script>
import TokenInput from '@/shared/components/ui/TokenInput'
export default {
    components: {
        TokenInput
    },
    props: [
        'hash',
        'data',
        'codigoModal',
    ],
    data() {
        return {
            reenviar: false,
            token: ''
        }
    },
    mounted() {
        // this.enviaToken()
    },
    methods: {
        // async enviaToken() {
        //     this.reenviar = false
        //     this.$loading.show()
        //     const dados = {
        //         Acesso: {
        //             email: this.usuario.email || '',
        //             codigo_autorizacao: this.token,
        //             telefone: this.usuario.telefone || '',
        //             empresa_id: this.data.empresa_id,
        //             loja_id: this.data.loja_id
        //         },
        //         slug: this.slug
        //     }
        //     const res = await this.$api.post('/agenda_pro/meus_agendamentos/envia_codigo', dados)
        //     // const res = await this.$api.post(this.$urlBase + '/meus_agendamentos/envia_codigo', dados)
        //     this.timer = res.data ? res.data : 0
        //     if(res.status != 'success'){
        //         this.$notify.warning(res.message)
        //     }
        //     this.$loading.hide()
        // },
    }
}
</script>
<style scoped>
p {
    font-size: 20px;
}

@media only screen and (max-width: 767px) {
    .inputs-token {
        width: 100%!important;
    }

}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
